import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './OtpStrongAuth.css';
import { OtpInput } from '../index';
import { OTP_TEXTS, TYPE_CONSTANTS, OTP_REGEX, OTP_OVERLAY_HASH } from 'fk-cp-common-components/utils/OtpConstants';
import { freezeBodyScroll, allowBodyScroll, clearTheSpace, convertStringToRegex } from '../../Utils/Functions';
import styleSheet from '../../Utils/StyleConstants';
import { fkPay } from '../../Utils/SMSHelper';
/**
 * The props available out of this component are
 * @prop {string} sentTo - **expects mobile number to be displayed**
 * @function verifyOtpCallback - **handles onClick of verify Button**
 * @prop {boolean} isLoading - **expects isLoading to display auto capture text and loader when actual auto capture is occuring**
 * @prop {string} resendText - **expects resend link text**
 * @prop {string} autoCaptureText - **expects the text to display when autocapturing is happening or when incorrect otp entered or even something goes wrong**
 * @prop {boolean} error - **expects boolean to display error user experience when something goes wrong or otp is incorrect**
 * @prop {number} numInputs - **expects integer,  to show number of inputs on screen**
 * @prop {number} otpTimeOut - **expects integer to start timer for specified seconds**
 * @function resendOtpCallback - **handles onClick of resend link Button**
 * @function hideOtpOverlay -**handles overlay close callback**
 * @props {string} mode - **_expects SMS(in case of android)_ or _EMAIL(in case of ios and mobile web)_ string to start autocapture or not to do autocapture**
 */

class OtpStrongAuth extends Component {
	constructor(props) {
		super(props);

		const { isOtpOverlayVisible, error, resendText, autoCaptureText, didntGetOtpText, errorMessage } = this.props;

		this.state = {
			isOtpOverlayVisible,
			timer: '',
			otp: '',
			error,
			resendText,
			isLoading: false,
			errorMessage,
			didntGetOtpText,
			autoCaptureText,
			disableButton: false,
			userInteruptedAutoCapture: false
		};
		this._hashChange = this._hashChange.bind(this);
		this.hideBottomOverlay = this.hideBottomOverlay.bind(this);
	}

	onVerifyButtonClick(otpCheck) {
		this.props.verifyOtpCallback(otpCheck);
	}

	hideBottomOverlay(e) {
		e.stopPropagation();
		if (e.target.id === 'overlay') {
			this.hide();
		}
	}

	hide() {
		window.removeEventListener('hashchange', this._hashChange);
		this.setState(
			{
				isOtpOverlayVisible: false,
				timer: '',
				otp: '',
				isLoading: false,
				error: false,
				autoCaptureText: '',
				userInteruptedAutoCapture: true,
				didntGetOtpText: '',
				disableButton: false
			},
			() => {
				allowBodyScroll();
				this.props.hideOtpOverlay();
			}
		);
	}

	_hashChange = () => {
		if (location.hash === '') {
			this.hide();
		}
	};

	UNSAFE_componentWillMount() {
		const { mode, autoCaptureOtpConfig = OTP_REGEX, isSMSAutoCapturePossible } = this.props;
		if (this.state.isOtpOverlayVisible) {
			this.setOtpOverlayStatesOnMode(mode, autoCaptureOtpConfig, isSMSAutoCapturePossible);
		}
	}

	componentDidUpdate(nextProps, nextState) {
		if (this.state.userInteruptedAutoCapture !== nextState.userInteruptedAutoCapture) {
			if (this.state.userInteruptedAutoCapture && this.props.mode === 'SMS') {
				this.stopListeningBridge();
			}
		}
	}

	startAutoCapturingSMS(autoCaptureOtpConfig) {
		if (autoCaptureOtpConfig) {
			this.callBridge(autoCaptureOtpConfig);
		} else {
			return;
		}
	}

	componentWillUnmount() {
		allowBodyScroll();
		window.removeEventListener('hashchange', this._hashChange);
	}

	dontstartAutoCapturingSMS() {
		const { didntGetOtpText, resendText } = this.props;
		const { error } = this.state;
		this.setState({
			isOtpOverlayVisible: true,
			isLoading: false,
			error,
			autoCaptureText: '',
			resendText,
			didntGetOtpText,
			timer: ''
		});
	}

	setOtpOverlayStatesOnMode(mode, autoCaptureOtpConfig, isSMSAutoCapturePossible) {
		switch (mode) {
			case TYPE_CONSTANTS.SMS:
				if (autoCaptureOtpConfig && isSMSAutoCapturePossible) {
					this.startAutoCapturingSMS(autoCaptureOtpConfig);
				} else {
					this.dontstartAutoCapturingSMS();
				}
				break;
			case TYPE_CONSTANTS.EMAIL:
				this.dontstartAutoCapturingSMS();
				break;
			default:
				this.dontstartAutoCapturingSMS();
		}
	}

	isOtpOverlayHashInUrl() {
		return location.hash === OTP_OVERLAY_HASH;
	}

	goBack() {
		history.go(-1);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { resendText, mode, autoCaptureOtpConfig = OTP_REGEX, isSMSAutoCapturePossible } = nextProps;
		if (nextProps.isOtpOverlayVisible && !this.props.isOtpOverlayVisible) {
			freezeBodyScroll();
			this.setOtpOverlayStatesOnMode(mode, autoCaptureOtpConfig, isSMSAutoCapturePossible);
		} else if (!nextProps.isOtpOverlayVisible && this.props.isOtpOverlayVisible) {
			this.setState(
				{
					isOtpOverlayVisible: false,
					isLoading: false,
					error: false,
					autoCaptureText: '',
					resendText: '',
					didntGetOtpText: '',
					otp: ''
				},
				() => {
					allowBodyScroll();
				}
			);
		} else if (nextProps.error !== this.props.error) {
			if (nextProps.errorMessage) {
				this.setState({
					isLoading: false,
					error: true,
					errorMessage: nextProps.errorMessage ? nextProps.errorMessage : this.props.errorMessage,
					resendText
				});
			}
		}
		return;
	}

	callBridge(autoCaptureOtpConfig) {
		const { senderRegEx, otpRegEx, smsRegEx, otpTimeOut } = autoCaptureOtpConfig;
		const { error, autoCaptureText } = this.props;

		this.setState(
			{
				isOtpOverlayVisible: true,
				isLoading: true,
				error,
				autoCaptureText,
				userInteruptedAutoCapture: false
			},
			() => {
				this.startTimer(otpTimeOut);
			}
		);
		fkPay.startListeningToSms(senderRegEx, otpTimeOut, (status, message) => {
			if (status && message) {
				const autocapturedOtp = fkPay.extractOtpFromSMS(
					message,
					convertStringToRegex(smsRegEx),
					convertStringToRegex(otpRegEx)
				);
				if (autocapturedOtp) {
					this.setState(
						{
							isLoading: false,
							error: false,
							otp: autocapturedOtp,
							autoCaptureText: '',
							timer: '',
							resendText: this.props.resendText,
							didntGetOtpText: this.props.didntGetOtpText
						},
						() => this.props.autoCaptureSuccessCallback(autocapturedOtp)
					);
				}
			} else {
				fkPay.stopListeningToSms();
				this.dontstartAutoCapturingSMS();
			}
		});
	}

	stopListeningBridge() {
		fkPay.stopListeningToSms();
		this.dontstartAutoCapturingSMS();
	}

	startTimer(otpTimeOut) {
		const { isLoading } = this.state;
		let m = Math.floor(otpTimeOut / 60);
		let s = otpTimeOut % 60;

		m = m < 10 ? '0' + m : m;
		s = s < 10 ? '0' + s : s;
		this.setState({ timer: m + ':' + s });
		otpTimeOut -= 1;

		if (otpTimeOut >= 0 && isLoading) {
			setTimeout(() => {
				this.startTimer(otpTimeOut);
			}, 1000);
			return;
		}

		if (!isLoading) {
			this.setState({
				resendText: this.props.resendText,
				didntGetOtpText: this.props.didntGetOtpText,
				timer: '',
				autoCaptureText: '',
				isLoading: false
			});
			return;
		}
		this.setState({
			isLoading: false,
			error: false,
			didntGetOtpText: this.props.didntGetOtpText,
			resendText: this.props.resendText,
			timer: ''
		});
	}

	onOtpChange(otp) {
		const { numInputs } = this.props;
		const checkOtpLength = 2 * numInputs + (numInputs - 2);

		this.setState({ otp }, () => {
			if (this.state.otp.length === checkOtpLength) {
				if (this.state.error) {
					this.setState({ error: false, errorMessage: '' });
				}
			}
			if (this.props.autoSubmitOtp) {
				if (this.state.otp.length === checkOtpLength) {
					const otpCheck = clearTheSpace(this.state.otp);
					this.props.handleAutoSubmitOtp(otpCheck);
				}
			}
		});

		if (this.props.mode === 'EMAIL') {
			this.setState({ userInteruptedAutoCapture: false });
		} else {
			this.setState({ userInteruptedAutoCapture: true });
		}
	}

	renderButtonTextOrSpinner() {
		const { showButtonLoader, buttonText } = this.props;
		if (showButtonLoader) {
			return (
				<div className={styles['button-spinner']}>
					<div className={styles['loader']} />
				</div>
			);
		} else {
			return buttonText ? buttonText : OTP_TEXTS.BUTTON_TEXT;
		}
	}

	handlePastedDataIsNotNumber = () => {
		this.setState({
			error: true,
			errorMessage: OTP_TEXTS.PASTED_DATA_NOT_NUMBER
		});
	};

	renderOtpInputOnCondition = () => {
		const { otp, error } = this.state;
		const { numInputs, focusStyle } = this.props;
		console.log('🚀 ~ file: OtpStrongAuth.js:367 ~ OtpStrongAuth ~ focusStyle:', focusStyle);

		return (
			<OtpInput
				onChange={otpChangeValue => this.onOtpChange(otpChangeValue)}
				value={otp}
				numInputs={numInputs}
				shouldAutoFocus={this.props.shouldAutoFocus}
				isInputNum={false}
				errorStyle={styles['input-error-style']}
				hasErrored={error}
				inputStyle={!error ? styles['input'] : styles['input-error']}
				focusStyle={focusStyle}
				handlePastedDataIsNotNumber={this.handlePastedDataIsNotNumber}
			/>
		);
	};

	render() {
		const {
			timer,
			otp,
			isOtpOverlayVisible,
			isLoading,
			resendText,
			error,
			autoCaptureText,
			didntGetOtpText,
			errorMessage
		} = this.state;
		const { numInputs, resendOtpCallback, isIosInput } = this.props;

		const { DEFAULT_BUTTON_BACKGROUND, ACTIVE_BUTTON_BACKGROUND, WHITE_COLOR, GREY_COLOR } = styleSheet;
		const otpCheck = clearTheSpace(otp);
		if (isOtpOverlayVisible) {
			return (
				<div className={styles['overlay-container']}>
					<div className={styles['overlay']} id="overlay" onClick={this.hideBottomOverlay} />
					<div
						className={
							isIosInput === true ? styles['overlay-content-ios'] : styles['overlay-content-android']
						}>
						<div className={styles['overlay-wrapper']}>
							<div className={styles['overlay-header']}>
								<div className={styles['overlay-header-text']}></div>
							</div>

							<div className={styles['overlay-header']}>
								<div className={styles['overlay-header-text']}>Enter Verification OTP</div>
							</div>

							{/* {this.props.title ? (
                <div className={styles["overlay-header"]}>
                  <div className={styles["overlay-header-text"]}>
                    {this.props.title}
                  </div>
                </div>
              ) : null}
              {!this.props.hideDefaultDescription ? (
                <div className={styles["text-container"]}>
                  <div className={styles["text-description"]}>
                    {descriptionText} {` `}
                    <span className={styles["mobile-number"]}>{sentTo}</span>
                    {` `} {textAfterDescription}
                  </div>
                </div>
              ) : null}

              {this.props.descriptionTextFromResponse ? (
                <div className={styles["description-text"]}>
                  {this.props.descriptionTextFromResponse}{" "}
                  {this.props.maskedMobileNumber ? (
                    <span className={styles["masked-mobile-number"]}>
                      {this.props.maskedMobileNumber}
                    </span>
                  ) : null}
                </div>
              ) : null} */}

							<div>{this.renderOtpInputOnCondition()}</div>
							<div>
								{this.renderActionRow(
									isLoading,
									autoCaptureText,
									didntGetOtpText,
									errorMessage,
									timer,
									resendText,
									error,
									resendOtpCallback
								)}
							</div>
						</div>

						<div className={styles['button-container']}>
							<button
								onClick={this.onVerifyButtonClick.bind(this, otpCheck)}
								style={{
									backgroundColor:
										otpCheck.length === numInputs
											? ACTIVE_BUTTON_BACKGROUND
											: DEFAULT_BUTTON_BACKGROUND,
									color: otpCheck.length === numInputs ? WHITE_COLOR : GREY_COLOR
								}}
								disabled={otpCheck.length === numInputs ? false : true}
								className={styles['button']}>
								{this.renderButtonTextOrSpinner()}
							</button>
						</div>
					</div>
				</div>
			);
		}
		return null;
	}

	resendOtp() {
		this.setState(
			{
				didntGetOtpText: this.props.didntGetOtpText,
				autoCaptureText: '',
				timer: '',
				resendText: '',
				isLoading: true
			},
			() => {
				this.startTimer(this.props.retryDelay / 1000);
				this.props.resendOtpCallback();
			}
		);
	}

	renderResendOtpCallbackText = resendText => {
		return (
			<div className={styles['resend-otp']}>
				<div onClick={() => this.resendOtp()}>{resendText}</div>
			</div>
		);
	};

	renderOtpStatusMessage = autoCaptureText => {
		return <div className={styles['auto-capture-text']}>{autoCaptureText}</div>;
	};

	renderActionRow = (isLoading, autoCaptureText, didntGetOtpText, errorMessage, timer, resendText, error) => {
		if (isLoading && autoCaptureText && timer && !error) {
			return (
				<div className={styles['row-container']}>
					<div className={styles['spinner-container']}>
						<div className={styles['otp-loader']} />
					</div>
					{this.renderOtpStatusMessage(autoCaptureText)}
					<div className={styles['timer']}>{timer}</div>
				</div>
			);
		} else if ((!isLoading && didntGetOtpText, resendText && !error)) {
			return (
				<div className={styles['row-container']}>
					{this.renderOtpStatusMessage(didntGetOtpText)}
					{this.renderResendOtpCallbackText(resendText)}
				</div>
			);
		} else if (!isLoading && resendText && error && errorMessage) {
			return (
				<div className={styles['row-container']}>
					<div className={styles['error-text']}>{errorMessage}</div>
					{this.renderResendOtpCallbackText(resendText)}
				</div>
			);
		} else if (isLoading && didntGetOtpText && timer) {
			return (
				<div className={styles['row-container']}>
					{this.renderOtpStatusMessage(didntGetOtpText)}
					<div className={styles['resend-timer']}>{timer}</div>
				</div>
			);
		}
		return <br />;
	};
}

OtpStrongAuth.defaultProps = {
	isOtpOverlayVisible: OTP_TEXTS.IS_OTP_OVERLAY_VISIBLE,
	descriptionText: OTP_TEXTS.DESCRIPTION_TEXT,
	error: OTP_TEXTS.ERROR,
	mode: TYPE_CONSTANTS.EMAIL,
	resendText: OTP_TEXTS.RESEND_LINK,
	didntGetOtpText: OTP_TEXTS.DIDNT_GET_MESSAGE,
	errorMessage: OTP_TEXTS.INVALID_OTP,
	numInputs: OTP_TEXTS.NUM_OF_INPUTS,
	autoCaptureText: OTP_TEXTS.AUTO_CAPTURE,
	retryDelay: OTP_TEXTS.RETRY_DELAY,
	autoSubmitOtp: OTP_TEXTS.AUTO_SUBMIT_OTP,
	hideOtpOverlay: () => {},
	verifyOtpCallback: () => {},
	resendOtpCallback: () => {},
	autoCaptureSuccessCallback: () => {},
	autoCaptureOtpConfig: OTP_REGEX,
	isSMSAutoCapturePossible: false,
	handleHistory: true
};
OtpStrongAuth.propTypes = {
	isOtpOverlayVisible: PropTypes.bool,
	error: PropTypes.bool,
	resendText: PropTypes.string,
	autoCaptureText: PropTypes.string,
	didntGetOtpText: PropTypes.string,
	errorMessage: PropTypes.string,
	verifyOtpCallback: PropTypes.func,
	hideOtpOverlay: PropTypes.func,
	mode: PropTypes.string,
	autoCaptureOtpConfig: PropTypes.func,
	isSMSAutoCapturePossible: PropTypes.bool,
	numInputs: PropTypes.number,
	autoSubmitOtp: PropTypes.bool,
	handleAutoSubmitOtp: PropTypes.func,
	showButtonLoader: PropTypes.bool,
	buttonText: PropTypes.string,
	shouldAutoFocus: PropTypes.bool,
	resendOtpCallback: PropTypes.func,
	isIosInput: PropTypes.bool,
	retryDelay: PropTypes.number,
	focusStyle: PropTypes.any,
	autoCaptureSuccessCallback: PropTypes.func
};

export { OtpStrongAuth };
